import React, { useState } from "react"
import { useI18next } from "gatsby-plugin-react-i18next"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { SelectorText } from "../selector-text/SelectorText"
import { LanguagePickerModal } from "./LanguagePickerModal"
import { getFormattedLanguage } from "../../util/languageUtil"

export const LanguagePickerSelector = () => {
  const { language } = useI18next()
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal(true)
  }

  const hideModal = () => {
    setShowModal(false)
  }

  return (
    <>
      <SelectorText onClick={openModal}>
        <FontAwesomeIcon icon={solid("earth")} />{" "}
        {getFormattedLanguage(language)}
      </SelectorText>
      <LanguagePickerModal hideModal={hideModal} isVisible={showModal} />
    </>
  )
}
